<template>
    <div class="mylistwrap" v-if="isload">
        <div class="mylist" v-if="$common.basic.isarrayexist(infolist)">
            <dl class="avg listheader" v-if="!issmall">
                <dd>{{$common.dicword('username')}} </dd>
                <dd>{{$common.dicword('realname')}}</dd>
                <dd>{{$common.dicword('nickname')}}</dd>
                <dd>{{$common.dicword('mobile')}}</dd>
                <dd v-if="options.schid">{{$common.dicword('tokprogress')}}</dd>
                <dd v-else-if="options.lectureid">{{$common.dicword('participation')}}</dd>
                <dd v-else>{{$common.dicword('infoclass')}}</dd>
            </dl>
            <div class="listinfo">
                <dl class="avg" v-for="item in infolist" :key="item.id">
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('username',true)}}&nbsp;
                        </span>
                        <ffmember :username="item.username" :stuid="item.id"></ffmember>
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('realname',true)}}&nbsp;
                        </span>
                        {{item.realname}}
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('nickname',true)}}&nbsp;
                        </span>
                        {{item.showname}}
                    </dd>
                    <dd>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('mobile',true)}}&nbsp;
                        </span>
                        {{item.mobile}}
                    </dd>
                    <dd v-if="options.schid" class="progress">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('tokprogress',true)}}&nbsp;
                        </span>
                        <span class="box"><span class="past" :style="{width:item.x_perc+'%'}"></span></span>
                        <span>{{item.x_perc}}%</span>
                    </dd>
                    <dd v-else-if="options.lectureid">
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('participation',true)}}&nbsp;
                        </span>
                        {{item.x_attend}}
                    </dd>
                    <dd v-else>
                        <span class="smalltitle" v-if="issmall">
                            {{$common.dicword('infoclass',true)}}&nbsp;
                        </span>
                        {{$common.langinfo(item.x_group.title,item.x_group.title_en)}}
                    </dd>
                </dl>
            </div>

            <div class="ffpage">
                <el-pagination :small="issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                </el-pagination>
            </div>
        </div>
        <div class="memnorecord" v-else>{{$common.dicword('norecord')}}</div>
    </div>

</template>
<script>
    import { mixinsubpage } from "@/mixin/mixin"

    export default {
        name: 'Clearner',
        mixins: [mixinsubpage],
        data() {
            return {
                postact: 'tc_mem_learner',
            };
        },
        methods: {
            getdata: function () {
                this.$common.post(this.postjson, res => {
                    if (this.options.schid > 0) {
                        this.$common.each(res.infodata, item => {
                            item.x_perc = 0;
                            let pro = this.$common.basic.fffind(res.infodataext || [], 'mid', item.id);
                            if (this.$common.basic.isobjexist(pro)) {
                                item.x_perc = Math.round(pro.perc);
                            }
                        });
                    }
                    else if (this.options.lectureid > 0) {
                        this.$common.each(res.infodata, item => {
                            item.x_attend = '';
                            let pro = this.$common.basic.fffind(res.infodataext || [], 'mid', item.id);
                            if (this.$common.basic.isobjexist(pro)) {
                                item.x_attend = pro.isattend ? (this.$common.basic.chint2time(pro.timebegin / 60) + '/' + this.$common.basic.chint2time(pro.timeend / 60)) : this.$common.dicword('notattend');
                            }
                        });
                    }
                    else {
                        this.$common.each(res.infodata, item => {
                            item.x_group = this.$common.basic.fffind(this.grouplist, 'id', item.groupid);
                        });
                    }

                    this.infolist = res.infodata;
                    this.isload = true;
                });
            }

        }
    }
</script>
